<template>
  <div>
    <b-card no-body class="p-2 container-card">
      <b-row>
        <b-col cols="12" class="px-2">
          <div>
            <div class="d-flex justify-content-end mb-1">
              <add-button
                v-if="getPermissionModule('Inventory').adjust"
                :btn-label="'Inventory'"
                @click.native="onOpenModalCreateInventory"
              />
              <export-button v-if="getPermissionModule('Inventory').adjust" class="ml-2" @onExport="onOpenExportModal" />
            </div>
            <div class="d-flex flex-wrap justify-content-end">
              <div class="search-container mb-1">
                <search :on-search-input="onSetValueSearch" />
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <!-- <b-table
                :fields="fields"
                :items="inventoryTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table"
              > -->
              <b-table
                :fields="fields"
                :items="inventoryTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table-vertical"
              >
                <template #cell(actions)="data">
                  <div v-if="getPermissionModule('Inventory').adjust">
                    <manage-button
                      v-if="data.item.isdefault"
                      :btn-label="'Manage Master'"
                      :color="'#5E799A'"
                      @click.native="
                        $router.push(
                          '/inventory/privilege/manage-master/' +
                            data.item.inventory_id
                        )
                      "
                    />
                    <manage-button
                      v-else
                      :btn-label="'Manage Inventory'"
                      @click.native="
                        $router.push(
                          '/inventory/privilege/manage-custom/info/' +
                            data.item.inventory_id
                        )
                      "
                    />
                  </div>
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
    <inventory-create-modal
      v-if="modalType.createInventory"
      @onCloseModal="onCloseModalInventory"
    />
    <history-report-modal
      v-if="modalPopup.report"
      @onCloseModal="closeReportModal"
      :moduleTypeKey="defaultReportFilterType.module"
      :moduleKey="defaultReport.inventory"
    />
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";

import AddButton from "@/views/components/button/AddButton.vue";
import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";
import ManageButton from "@/views/components/button/ManageButton.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import useInventoryPrivilegeList from "./hooks/useInventoryPrivilegeList";
import InventoryCreateModal from "./components/InventoryCreateModal.vue";
import ExportButton from "@/views/components/button/ExportButton.vue";
import HistoryReportModal from "@/views/pages/report/history-report/HistoryReportModal.vue";
import {
  defaultReport,
  defaultReportFilterType,
  defaultReportCategory,
} from "@/configs/dynamic-config/dynamic-report";
export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    AddButton,
    Search,
    vSelect,
    ManageButton,
    InventoryCreateModal,
    PaginationWithReorder,
    ExportButton,
    HistoryReportModal,
  },
  setup() {
    const {
      isDefaultInList,
      pagination,
      fields,
      loading,
      inventoryTable,
      modalType,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onCloseModalInventory,
      onOpenModalCreateInventory,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
      getPermissionModule
    } = useInventoryPrivilegeList();
    return {
      isDefaultInList,
      pagination,
      fields,
      loading,
      inventoryTable,
      modalType,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onCloseModalInventory,
      onOpenModalCreateInventory,
      defaultReport,
      defaultReportFilterType,
      defaultReportCategory,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
      getPermissionModule
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
</style>
